import { firestore } from "@/firebase";
import { authStateAtom } from "@/orm/auth";
import { collection, doc } from "firebase/firestore";
import { useAtomValue } from "jotai";
import { useDocument } from "react-firebase-hooks/firestore";

type UserAccount = {
  customerId: string;
};

export const useUserAccount = () => {
  const { user } = useAtomValue(authStateAtom);

  const [snapshot, loading, error] = useDocument(
    user?.uid ? doc(collection(firestore, `userAccount`), user?.uid) : null,
  );

  const result = !snapshot
    ? undefined
    : snapshot?.exists()
      ? (snapshot.data() as UserAccount)
      : null;

  return [
    result,
    !user?.uid || snapshot === undefined || loading,
    error,
  ] as const;
};
